export default __webpack_public_path__ + "static/bca-0a949caff27614698e3f7a6bdab37694.jpg";